import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { TextContent } from '../TextContent/TextContent';
import './LogoModule.scss';

export const LogoModule = ({ node }) => {
    const img = node.relationships?.field_images;
    if (!img || img.length <= 2) {
        return (
            <p className="component-error">
                ERROR: This component must a minimum of 3 images/logos.
            </p>
        );
    }

    return (
        <section
            className={`themed-container c--logo-module ${node.field_theme?.toLowerCase()}`}
        >
            <div className="logo-module-inner">
                {(node.field_content_text?.value ||
                    node.field_eyebrow_text ||
                    node.field_heading) && <TextContent node={node} />}
                <div className="image-set">
                    {img &&
                        node.relationships?.field_images?.map((image, idx) => {
                            const gImage = getImage(
                                image.relationships?.field_media_image
                                    ?.localFile
                            );
                            return (
                                <GatsbyImage
                                    image={gImage}
                                    key={idx}
                                    alt={image.field_media_image?.alt}
                                    objectFit="contain"
                                />
                            );
                        })}
                </div>
            </div>
        </section>
    );
};
